Promise.wait = (ms, result) => {
    return new Promise(res => {
        setTimeout(() => res(result), ms);
    });
};

export default null;
